import { useParams } from "react-router-dom";
import i18n from "@/i18n";
import { AuditsEditCard } from "./edit_card";

const client = "admin-quantilia";
const table_name = "audits";

export const AuditsCard = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <AuditsEditCard
          id={Number(id)}
          client={client}
          table_name={table_name}
        />
      </div>
    </div>
  );
};
